import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { buildTrackingId } from '@/utils/tracking-helper';
import CelebrateIcon from '../../../../../public/images/celebrate-icon.svg';
import Button from '../../shared/Button';

export type NukiPremiumReferFriendFormSentProps = {
  formData: NukiPremiumReferFriendFormData;
  trackingPrefix?: string;
};

export type NukiPremiumReferFriendFormData = {
  referrerFirstName: string;
  referrerLastName: string;
  referrerEmail: string;
  referralEmails: string[];
  language?: string;
  privacyPolicy: boolean;
};

export function NukiPremiumReferFriendFormSent({
  formData,
  trackingPrefix,
}: Readonly<NukiPremiumReferFriendFormSentProps>) {
  const t = useTranslations('NukiPremiumReferFriendInviteSent');
  const { referrerEmail, referrerFirstName, referrerLastName } = formData;

  // current URL
  const currrentUrl = new URL(globalThis.location.href);
  currrentUrl.searchParams.set('referrerEmail', referrerEmail);
  currrentUrl.searchParams.set('referrerFirstName', referrerFirstName);
  currrentUrl.searchParams.set('referrerLastName', referrerLastName);

  return (
    <div className="flex justify-center">
      <div className="max-w-[56rem] overflow-y-hidden px-6">
        <div className="mb-8 flex justify-center">
          <Image
            src={CelebrateIcon}
            alt=""
            width={32}
            height={32}
            className="h-14 w-14 sm:h-20 sm:w-20"
          />
        </div>
        <div className="mb-8 text-center sm:mb-12">
          <h1 className="mb-6 text-xl font-bold sm:mb-8 sm:text-4xl">
            {t('titleInviteSent')}
            <span className="text-primary-100">!</span>
          </h1>

          <p className="mb-6 sm:mb-12 sm:text-xl">{t('subtitleInviteMore')}</p>

          <Button
            className="inline-flex items-center"
            onClick={() => {
              globalThis.location.href = currrentUrl.toString();
            }}
            data-tile-element-id={buildTrackingId(trackingPrefix, 'invite-more')}
          >
            {t('buttonInviteMore')}
          </Button>
        </div>
      </div>
    </div>
  );
}
